import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import StandAloneFooter from "./StandAloneFooter";
import { Icon } from '@iconify/react/dist/iconify.js';

const StandAloneComplaintMasterLayout = ({ children }) => {
  let [mobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* <main className="dashboard-main"> */}
      <main className={"standalone-dashboard-main active"}>
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            {/* Logo */}
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center">
                <label
                  className="d-flex align-items-center"
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src="assets/images/logo/forest_logo_fw.png"
                    alt="Logo"
                    className="ms-2 mr-3 img-fluid"
                    style={{
                      width: "100px", // Reduced width for small screens
                      height: "auto", // Reduced height for small screens
                      marginRight: "10px", // Reduced margin for small screens
                      borderRadius: "8px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                </label>
              </div>
            </div>
            {/* Department Name */}
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center">
                <label
                  className="d-flex align-items-center"
                  style={{ cursor: "pointer" }}
                >
                  <span
                    className="ps-4 fw-semibold text-uppercase d-none d-sm-flex h_title"
                    style={{
                      letterSpacing: "0.5px",
                      color: "#2c3e50",
                      fontSize: "1.4rem",
                    }}
                  >
                    <Icon icon="mdi:file-document-alert" className="text-5xl mx-3 my-1" />
                    Complaint Management Form
                  </span>
                </label>
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                
              </div>
            </div>
          </div>
        </div>

        <div className="standalone-dashboard-main-body"
            style={{
            flex: "1 0 auto", // Allow the main body to grow and fill available space
            position: "relative",
            overflow: "auto", // Allow scrolling if content overflows
                    }}>
                      {children}
         </div>
        <StandAloneFooter />
      </main>

      
    </section>
  );
};

export default StandAloneComplaintMasterLayout;